import { render } from "./CustomTopicModel.vue?vue&type=template&id=7170343f"
import script from "./CustomTopicModel.vue?vue&type=script&lang=js"
export * from "./CustomTopicModel.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__